import { context, utils } from '@ad-engine/core';

export class PlacementsBuilder {
	public buildStandaloneAdUnit(): Element {
		const defaultClasses = ['openweb-ad-unit'];
		const divElement = document.createElement('div');
		divElement.dataset.openwebAd = '';
		divElement.dataset.row = '1';
		divElement.dataset.column = '1';

		// Update classes based on if stickyRightRail is active
		if (context.get('experiments.stickyRightRail')) {
			defaultClasses.push(utils.STICKY_RAIL_MODULE_STICKY_CLASS);
		}

		divElement.classList.add(...defaultClasses);

		return divElement;
	}
}
